








import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = '20230531CQBGY';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '作品展示',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '我要报名',
      path: `/${baseUrl}/save`,
      id: 1,
    },
    {
      title: '活动简介',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
    {
      title: '相关新闻',
      path: `/${baseUrl}/News`,
      id: 1,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '“重新杯”首届城市儿童公益作品展',
      url: location.href,
      subtitle: `“重新杯”首届城市儿童公益作品展`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '“重新杯”首届城市儿童公益作品展',
        subtitle: `“重新杯”首届城市儿童公益作品展`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
